export const OTHER_ADDRESS_OPTION = 'Otro';

export function emptyAddressLookupPatch() {
  return {
    state: '',
    stateName: '',
    municipality: '',
    municipalityName: '',
    colony: '',
    colonyName: '',
  };
}

export function mapLabelOptions(items = []) {
  const seen = new Set();
  const options = [];
  items.forEach((item) => {
    const label = String(item?.label || '').trim();
    if (!label || seen.has(label)) return;
    seen.add(label);
    options.push({ value: label, label });
  });
  return options;
}

export function mapCityOptions(cities = []) {
  return (cities || []).map((city) => {
    const label = String(city?.label || '').trim();
    if (!label) return null;
    return {
      value: label,
      label,
      colonies: mapLabelOptions(city.colonies || []),
    };
  }).filter(Boolean);
}

export function coloniesForCity(cityOptions = [], municipalityName = '') {
  const selected = cityOptions.find((city) => city.value === municipalityName);
  if (selected) return selected.colonies || [];
  if (cityOptions.length === 1) return cityOptions[0].colonies || [];
  return [];
}

/**
 * Colonia tiene catálogo si el CP trajo municipios y, una vez
 * elegido el municipio, ese municipio trae colonias.
 * Si aún no hay municipio, no caer a "Otro".
 */
export function colonyHasCatalogData(cityOptions = [], municipalityName = '') {
  if (!cityOptions.length) return false;
  const resolved = municipalityName
    || (cityOptions.length === 1 ? cityOptions[0].value : '');
  if (!resolved) return true;
  return coloniesForCity(cityOptions, resolved).length > 0;
}
